export default function Card({ card }) {
    return (
        <div className="card-item">
            <img
                src={card.char_img}
                alt={card.char_name}
                className="card-image"
            />
            <div className="card-info">
                <strong>{card.char_name}</strong>
                <span>Síla: {card.base_power}</span>
                {card.qty > 1 && <span> × {card.qty}</span>}
            </div>
        </div>
    );
}
